import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=7f2f950c&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=7f2f950c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f950c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2f950c')) {
      api.createRecord('7f2f950c', component.options)
    } else {
      api.reload('7f2f950c', component.options)
    }
    module.hot.accept("./PaymentMethod.vue?vue&type=template&id=7f2f950c&scoped=true", function () {
      api.rerender('7f2f950c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/PaymentMethod.vue"
export default component.exports